/**
 * Fleet Remediation erişim kontrolü — GEÇİCİ (hems-ssh-devices/access.ts ile AYNI).
 *
 * Roller backend'de henüz yok → sayfa sadece süper admin'e açık (e-posta allowlist).
 * Backend de aynı kontrolü yapar (hems-ssh-api `SUPERADMIN_EMAILS`, require_superadmin).
 */
const REMEDIATION_SUPERADMIN_EMAILS = ["admin@oklidis.com.tr"] as const

// Lokal dev istisnası: mock login "admin@oklidis.com" (.tr YOK). import.meta.env.DEV
// sadece `npm run dev`'de true; her build false → canlıda yine `.tr` şartı geçerli.
const REMEDIATION_DEV_PREVIEW_EMAILS = ["admin@oklidis.com"] as const

export function canAccessFleetRemediation(email: string | null | undefined): boolean {
  if (!email) {
    return false
  }
  const normalized = email.trim().toLowerCase()
  if (REMEDIATION_SUPERADMIN_EMAILS.includes(normalized as never)) {
    return true
  }
  if (import.meta.env.DEV && REMEDIATION_DEV_PREVIEW_EMAILS.includes(normalized as never)) {
    return true
  }
  return false
}
